import { render, staticRenderFns } from "./OtherStuff.vue?vue&type=template&id=462651f8&scoped=true&"
import script from "./OtherStuff.vue?vue&type=script&lang=ts&"
export * from "./OtherStuff.vue?vue&type=script&lang=ts&"
import style0 from "./OtherStuff.vue?vue&type=style&index=0&id=462651f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462651f8",
  null
  
)

export default component.exports